import axios from "axios";
import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/Url";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";

export const UserReports = () => {
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [loading, setLoading] = useState(true);

  // Search aur filters ke states
  const [searchQuery, setSearchQuery] = useState("");
  const [reasonFilter, setReasonFilter] = useState("");

  const navigate = useNavigate();

  const fetchReports = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const { data } = await axios.get(`${API_URL}/api/user/get-report-users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setReports(data?.userReport || []);
      setFilteredReports(data?.userReport || []);
    } catch (error) {
      console.error("Fetch Error:", error);
      toast.error("Failed to load reports");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  // Filter Logic (Search by Name/Email & Reason Filter)
  useEffect(() => {
    let updated = [...reports];

    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase();
      updated = updated.filter(
        (r) =>
          r.reportedBy?.name?.toLowerCase().includes(query) ||
          r.reportedBy?.email?.toLowerCase().includes(query) ||
          r.reportedUser?.name?.toLowerCase().includes(query),
      );
    }

    if (reasonFilter !== "") {
      updated = updated.filter((r) => r.reason === reasonFilter);
    }

    setFilteredReports(updated);
  }, [searchQuery, reasonFilter, reports]);

  // Unique reasons list nikalne ke liye select options ke liye
  const uniqueReasons = [
    ...new Set(reports.map((r) => r.reason).filter(Boolean)),
  ];

  return (
    <>
      <Header />
      <Sidebar />

      <div
        className="mt-5 main-content px-3 px-md-4 py-4"
        style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}
      >
        {/* PREMIUM HEADER SECTION */}
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3 mb-4 p-3 bg-white border rounded-4 shadow-sm">
          <div>
            <h2 className="fw-bold text-gray-800 mb-0 fs-3">
              User Reports Management
            </h2>
            <p className="text-muted small mb-0">
              Review complaints and flags submitted by members
            </p>
          </div>
          <div className="bg-danger-subtle px-3 py-2 rounded-3 border border-danger-subtle">
            <span className="text-danger fw-semibold me-1">Total Flags:</span>
            <span className="fw-bold text-danger fs-5">
              {filteredReports.length}
            </span>
          </div>
        </div>

        {/* SEARCH & FILTER CONTROLS */}
        <div className="card border-0 rounded-4 shadow-sm mb-4">
          <div className="card-body p-3">
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <label className="form-label small fw-semibold text-muted">
                  Search Members
                </label>
                <div className="input-group">
                  <span className="input-group-text bg-light border-light-subtle text-muted">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control rounded-end-3 border-light-subtle bg-light-subtle"
                    placeholder="Search by reporter name, email, or target user..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label small fw-semibold text-muted">
                  Filter by Violation Reason
                </label>
                <select
                  className="form-select rounded-3 border-light-subtle bg-light-subtle fw-medium"
                  value={reasonFilter}
                  onChange={(e) => setReasonFilter(e.target.value)}
                >
                  <option value="">All Violation Reasons</option>
                  {uniqueReasons.map((reason, i) => (
                    <option key={i} value={reason}>
                      {reason}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* DATA CONTAINER */}
        {loading ? (
          <div className="d-flex flex-column align-items-center justify-content-center py-5 card border-0 shadow-sm rounded-4">
            <div
              className="spinner-border text-danger mb-3"
              role="status"
            ></div>
            <span className="text-muted fw-medium">
              Loading moderation queue...
            </span>
          </div>
        ) : (
          <div className="card border-0 rounded-4 shadow-sm overflow-hidden">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0 custom-admin-table">
                  <thead className="bg-light border-bottom">
                    <tr>
                      <th className="text-muted text-uppercase fs-7 fw-bold px-4 py-3">
                        Reported By
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                        Offending Target User
                      </th>
                      <th
                        className="text-muted text-uppercase fs-7 fw-bold py-3"
                        style={{ maxWidth: "350px" }}
                      >
                        Violation Details
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                        Submitted On
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold px-4 py-3 text-end">
                        Profile Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody className="border-0">
                    {filteredReports.length > 0 ? (
                      filteredReports.map((item) => (
                        <tr
                          key={item._id}
                          className="align-middle transition-all"
                        >
                          {/* Reporter Details */}
                          <td className="px-4">
                            <div
                              className="fw-bold text-dark"
                              style={{ fontSize: "14px" }}
                            >
                              {item.reportedBy?.name || "Unknown User"}
                            </div>
                            <div className="text-muted font-monospace fs-7">
                              {item.reportedBy?.email}
                            </div>
                          </td>

                          {/* Target User Details */}
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <span className="badge bg-danger rounded-circle p-1 d-inline-block"></span>
                              <span
                                className="fw-bold text-danger-emphasis"
                                style={{ fontSize: "14.5px" }}
                              >
                                {item.reportedUser?.name || "N/A"}
                              </span>
                            </div>
                          </td>

                          {/* Reason and Custom Message */}
                          <td style={{ maxWidth: "350px" }}>
                            <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-2.5 py-1.5 rounded fw-bold text-capitalize fs-7 mb-1 d-inline-block">
                              {item.reason || "General Flag"}
                            </span>
                            {item.message && (
                              <p
                                className="text-secondary small mb-0 text-wrap font-sans bg-light p-2 rounded border border-light-subtle mt-1"
                                style={{ fontSize: "13px", lineHeight: "1.4" }}
                              >
                                "{item.message}"
                              </p>
                            )}
                          </td>

                          {/* Date Flagged */}
                          <td className="text-muted fs-7">
                            {item.createdAt
                              ? new Date(item.createdAt).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  },
                                )
                              : "—"}
                          </td>

                          {/* Operational Control Buttons */}
                          <td className="px-4 text-end">
                            <div className="d-flex justify-content-end gap-2 flex-wrap flex-md-nowrap">
                              <button
                                onClick={() =>
                                  navigate(
                                    `/user-details/${item.reportedUser?._id}`,
                                  )
                                }
                                className="btn btn-sm btn-outline-danger fw-semibold d-inline-flex align-items-center gap-1 shadow-xs px-2.5"
                                disabled={!item.reportedUser?._id}
                              >
                                <i className="bi bi-shield-slash"></i> Target
                              </button>
                              <button
                                onClick={() =>
                                  navigate(
                                    `/user-details/${item.reportedBy?._id}`,
                                  )
                                }
                                className="btn btn-sm btn-light border fw-medium d-inline-flex align-items-center gap-1 text-muted px-2.5"
                                disabled={!item.reportedBy?._id}
                              >
                                <i className="bi bi-person"></i> Reporter
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-5">
                          <div className="text-muted d-flex flex-column align-items-center justify-content-center gap-2">
                            <i className="bi bi-shield-check text-success fs-1"></i>
                            <p className="mb-0 fw-semibold fs-5 text-dark">
                              All clean! No reports found
                            </p>
                            <p className="mb-0 text-muted small">
                              No community violations match the applied filter
                              query.
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
